import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '../../services/translate/translate.service';
import { Subscription, firstValueFrom } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { IPkSk, Version } from '../../interfaces/versions.interface';

interface translateModalVersion {
  title: string;
  module: string;
  nameModule: string;
  version: string;
  date: string;
  notes: string;
  features: string;
  improviments: string;
}

@Component({
  selector: 'mg-modal-version',
  templateUrl: './modal-version.component.html',
  styleUrls: ['./modal-version.component.scss'],
})
export class ModalVersionComponent implements OnDestroy {
  translate!: translateModalVersion;
  version: Version = {
    version: '',
    date: '',
    improvements: [],
    features: [],
  };
  subscriptionTranslate!: Subscription;

  constructor(
    public dialogRef: MatDialogRef<ModalVersionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { version: string; ids: IPkSk },
    private translateService: TranslateService,
    private authservice: AuthenticationService
  ) {
    this.version.version = this.data.version;
    this.dataTranslate();
    this.getVersion();
  }

  dataTranslate() {
    this.subscriptionTranslate = this.translateService
      .init('core')
      .subscribe((data) => {
        this.translate = data.toolbar.modalVersion;
      });
  }

  async getVersion() {
    const version: Version = await firstValueFrom(
      this.authservice.getInfoVersion(
        this.data.version,
        this.data.ids.pk,
        this.data.ids.sk
      )
    );
    if (version?.date) {
      this.version = version;
    }
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
